// VG 2.0 · Property Advisor Workspace client.
//
// LAUNCH-C2 — production auth: the Property Advisor is identified
// server-side from the JWT Bearer token carried by the shared `api`
// axios instance (which already attaches `Authorization: Bearer
// <vg2_token>` and handles 401 centrally). No `X-PA-Id`, no preview
// identity. Per-case authorization stays server-side (`_authorize_pa`).
import { api } from "./api";

// Map an axios error onto the shape the UI already reads (`e.status`,
// `e.code`). FastAPI `detail` may be an object (with `error_code`) or a
// plain string — handle both.
function _adaptError(error) {
  const resp = error?.response;
  const detail = resp?.data?.detail;
  const backendCode =
    detail && typeof detail === "object" ? detail.error_code : undefined;
  const err = new Error(
    (detail && typeof detail === "object" && detail.message) ||
      (typeof detail === "string" ? detail : undefined) ||
      error?.message ||
      "Errore imprevisto."
  );
  err.status = resp?.status;
  err.code = backendCode || resp?.status || error?.code || null;
  return err;
}

async function _call(run) {
  try {
    return (await run()).data;
  } catch (e) {
    throw _adaptError(e);
  }
}

export function getPaCases() {
  return _call(() => api.get("/v2/pa/cases"));
}

export function getPaCaseDetail({ caseId }) {
  return _call(() => api.get(`/v2/pa/cases/${encodeURIComponent(caseId)}`));
}

export function getPaEntries({ caseId }) {
  return _call(() =>
    api.get(`/v2/pa/cases/${encodeURIComponent(caseId)}/entries`)
  );
}

export function postPaEntry({ caseId, payload }) {
  return _call(() =>
    api.post(`/v2/pa/cases/${encodeURIComponent(caseId)}/entries`, payload)
  );
}

export function postPaCallSummary({ caseId, payload }) {
  return _call(() =>
    api.post(
      `/v2/pa/cases/${encodeURIComponent(caseId)}/call-summary`,
      payload
    )
  );
}

export function newOperationId(prefix = "op") {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
